import React from 'react';
import { ScoreGauge } from './ScoreGauge';
import { VerdictBanner } from './VerdictBanner';
import { CheckList } from './CheckList';
import { ReportExport } from './ReportExport';
import type { ScanResult } from '../../types/scanner';

interface ScanResultsProps {
  result: ScanResult;
  scanId: string;
  url?: string;
}

export const ScanResults: React.FC<ScanResultsProps> = ({ result, scanId, url }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-6)' }}>
      {/* Verdict Banner */}
      <VerdictBanner verdict={result.verdict} score={result.score} />

      {/* Score and Summary Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 'var(--space-6)' }}>
        {/* Score Gauge */}
        <div className="card">
          <div className="card-body" style={{ display: 'flex', justifyContent: 'center', padding: 'var(--space-8)' }}>
            <ScoreGauge score={result.score} verdict={result.verdict} size="lg" />
          </div>
        </div>

        {/* Summary Stats */}
        <div className="card">
          <div className="card-header">Scan Summary</div>
          <div className="card-body">
            <dl style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
              {url && (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <dt style={{ color: 'var(--color-muted)' }}>URL</dt>
                  <dd style={{ fontWeight: 500, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{url}</dd>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <dt style={{ color: 'var(--color-muted)' }}>Total Checks</dt>
                <dd style={{ fontWeight: 600, fontFamily: 'var(--font-mono)' }}>{result.summary.total}</dd>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <dt style={{ color: 'var(--color-muted)' }}>Passed</dt>
                <dd style={{ fontWeight: 600, fontFamily: 'var(--font-mono)', color: 'var(--color-success)' }}>{result.summary.passed}</dd>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <dt style={{ color: 'var(--color-muted)' }}>Failed (Critical)</dt>
                <dd style={{ fontWeight: 600, fontFamily: 'var(--font-mono)', color: 'var(--color-error)' }}>{result.summary.failed}</dd>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <dt style={{ color: 'var(--color-muted)' }}>Warnings</dt>
                <dd style={{ fontWeight: 600, fontFamily: 'var(--font-mono)', color: '#eab308' }}>{result.summary.warnings}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

      {/* Export Options */}
      <div className="card">
        <div className="card-header">Export Report</div>
        <div className="card-body">
          <ReportExport scanId={scanId} />
        </div>
      </div>

      {/* Issues List */}
      <div className="card">
        <div className="card-header">
          Compliance Issues ({result.allIssues.length})
        </div>
        <div className="card-body">
          <CheckList issues={result.allIssues} />
        </div>
      </div>
    </div>
  );
};

export default ScanResults;
